<template>
  <div class="page-container">
    <div class="query-title">积分使用记录查询</div>

    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="120px">
              <el-row :gutter="12">
                <el-col v-if="!isWLY001" :span="8">
                  <el-form-item label="客户编号">
                    <el-input v-model="queryForm.distributerId" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="积分获得明细编码">
                    <el-input v-model="queryForm.pointDetailId" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="使用积分订单号">
                    <el-input v-model="queryForm.usageOrderNumber" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="使用状态">
                    <el-select v-model="queryForm.usageStatus" clearable placeholder="请选择">
                      <el-option label="冻结" value="FREEZE" />
                      <el-option label="使用" value="USED" />
                      <el-option label="取消" value="CANCEL" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="积分使用方式">
                    <el-select v-model="queryForm.pointUsage" clearable placeholder="请选择">
                      <el-option label="折扣" value="DISCOUNT" />
                      <el-option label="兑换" value="EXCHANGE" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="积分使用时间">
                    <el-date-picker
                      v-model="queryForm.dateRange"
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      range-separator="至"
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="query-actions">
                <el-button size="mini" icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
                <el-button size="mini" type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
              </div>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon title="查询结果" :custome-config="() => vxeShowCustom('xTable')">
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :loading="loading"
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="400"
            align="center"
            size="mini"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :columns="gridColumns"
            :data="tableData"
          />
          <div class="pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              :current-page="pagination.currentPage"
              :total="pagination.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </TableCommon>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDistributerPointUsePage } from '@/api/integralManage/index'
import { frontExport } from '@/utils/frontExport'
import { mapGetters } from 'vuex'

const USAGE_STATUS_TEXT = {
  FREEZE: '冻结',
  USED: '使用',
  CANCEL: '取消'
}

const POINT_USAGE_TEXT = {
  DISCOUNT: '折扣',
  EXCHANGE: '兑换'
}

const defaultQuery = () => ({
  distributerId: '',
  pointDetailId: '',
  usageOrderNumber: '',
  usageStatus: '',
  pointUsage: '',
  dateRange: []
})

export default {
  name: 'IntegralPointUseReport',
  computed: {
    ...mapGetters(['customerInfo', 'role']),
    isWLY001() {
      return this.role && this.role.ROLE === 'WLY001'
    }
  },
  data() {
    return {
      loading: false,
      queryForm: defaultQuery(),
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      gridColumns: [
        { type: 'seq', width: 50, title: '序号', align: 'center' },
        { field: 'detailId', title: '积分明细编码', minWidth: 140 },
        { field: 'usedPointAmount', title: '积分使用数量', minWidth: 140 },
        { field: 'distributerId', title: '客户编码', minWidth: 140 },
        { field: 'distributerName', title: '客户名称', minWidth: 200 },
        {
          field: 'pointUsage',
          title: '积分用途',
          minWidth: 120,
          formatter: ({ cellValue }) => POINT_USAGE_TEXT[cellValue] || cellValue || ''
        },
        { field: 'usageOrderNumber', title: '用途单号', minWidth: 160 },
        {
          field: 'usageStatus',
          title: '使用状态',
          minWidth: 120,
          formatter: ({ cellValue }) => USAGE_STATUS_TEXT[cellValue] || cellValue || ''
        },
        { field: 'usageTime', title: '使用时间', minWidth: 170 }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleSearch() {
      this.fetchData(1)
    },
    handleReset() {
      this.queryForm = defaultQuery()
      this.fetchData(1)
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.fetchData(1)
    },
    handleCurrentChange(page) {
      this.fetchData(page)
    },
    buildPayload() {
      const payload = {
        currentpage: String(this.pagination.currentPage - 1),
        pagesize: String(this.pagination.pageSize)
      }

      const { distributerId, pointDetailId, usageOrderNumber, usageStatus, pointUsage, dateRange } = this.queryForm

      // 如果是WLY001，使用当前登录用户的客户编码
      // 如果不是WLY001，只使用查询条件中的客户编号，不传递默认登录人
      if (this.isWLY001) {
        const currentUserDistributerId = (this.customerInfo && this.customerInfo.info && this.customerInfo.info.partner) ||
                                          (this.role && this.role.USER_BP) || ''
        if (currentUserDistributerId) {
          payload.distributerId = String(currentUserDistributerId).trim()
        }
      } else {
        // 非WLY001角色，只使用查询条件中的客户编号，不传递默认登录人
        if (distributerId) {
          payload.distributerId = distributerId.trim()
        }
        // 如果没有输入客户编号，不传递 distributerId 参数
      }

      if (pointDetailId) payload.pointDetailId = pointDetailId.trim()
      if (usageOrderNumber) payload.usageOrderNumber = usageOrderNumber.trim()
      if (usageStatus) payload.usageStatus = usageStatus
      if (pointUsage) payload.pointUsage = pointUsage
      if (dateRange && dateRange.length === 2) {
        payload.beginTime = dateRange[0]
        payload.endTime = dateRange[1]
      }

      return payload
    },
    async fetchData(page = this.pagination.currentPage) {
      this.loading = true
      this.pagination.currentPage = page
      try {
        const params = this.buildPayload()
        const res = await fetchDistributerPointUsePage(params)
        if (!res || res.status !== 1) {
          this.tableData = []
          this.pagination.total = 0
          this.$message.error((res && res.msg) || '查询失败')
          return
        }
        const rows = (res.data && res.data.Rows) || []
        const total = (res.data && res.data.Total) || 0
        this.tableData = rows
        this.pagination.total = total
      } catch (error) {
        this.tableData = []
        this.pagination.total = 0
        this.$message.error('查询异常，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    exportExcel() {
      frontExport(this.gridColumns, this.tableData, '积分使用记录查询')
    }
  }
}
</script>

<style lang="scss" scoped>
.query-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.query-container {
  padding: 0 8px;
}

.query-actions {
  margin-top: 12px;
  display: flex;
  gap: 12px;
}

.pagination {
  margin-top: 12px;
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/views/integral-manage/pointUseReport.vue